import { ReportQuestionsService } from './report-questions.service';

export default angular
  .module('sfMobile.services.reportQuestions', ['sfMobile.services.forms'])
  .factory('reportQuestionsService', ReportQuestionsService).name;
